export const CONFETTI_OPTIONS = {
    count: 200,
    defaults: {
        origin: { y: 0.7 }
    }
};

export const ABSTRACT = {
    SELECTORS: {
        back: "[data-back]",
        cancel: 'button[type="reset"]',
        form: ".std-form",
        next: "[data-next]",
        submit: "[data-submit]",
        tabs: "[data-tab]",
        step: ".step",
        already_customer: ":scope #already_customer",
        street: ":scope #street",
        zip_code: ":scope #plz",
        city: ":scope #city"
    }
};

export const JOB_APPLICATION = {
    SELECTORS: {
        form: "#job-application-form",
        submitButton: "[data-submit]",
        cancelButton: '[type="reset"]'
    },
    FORM_ACTION: "/apps/job-request/api/submit-job-application"
};

export const RENTAL = {
    SELECTORS: {
        page: "main.collection.rental",
        sidebar: ".product-filters-sidebar-rental",
        productGrid: ".product-grid",
        moreFilters: ".more-filters",
        tab: ".filter-tabs .item",
        productTile: ":scope .product-tile",
        hide: "hide-me",
        summary: ":scope .summary",
        datePicker: ".date-picker",
        datePickerInitializer: "#date-range-picker-sidebar",
        form: "#rental-filters",
        locationInputs: '[name="location"]',
        drivingLicenseInputs: '[name="driving-license"]',
        rentalClassInputs: '[name="rental-class"]',
        disabled: "disabled",
        submitFilters: "#submit-filters",
        sortingInput: '[data-type="sort"]',
        filterInputs: '[data-type="filter"]'
    },
    RENTAL_CLASS_COLLECTION: "Mietfahrzeuge",
    ALL: "all",
    DEFAULT_SORTING: "most-rented"
};

export const SPARE_PARTS = {
    SELECTORS: {
        section: "#spare-parts-form",
        form: ".std-form",
        otherInput: "#other",
        serviceTab: '[data-tab="service"]'
    }
};

export const WARRANTY_CLAIM = {
    SELECTORS: {
        form: "#warranty-claim",
        numberInputs: '[inputmode="decimal"]',
        submitButton: '[type="submit"]'
    },
    FORM_ACTION: "/apps/rental-appointment/api/submit-warranty-claim-request",
    FORM_ACTION_EBIKE: "/apps/rental-appointment/api/submit-warranty-claim-request-ebike"
};

export const PERSONAL_CONSULTATION = {
    REQUEST_TYPES: {
        lim: "personal-consultation",
        ebike: "ebike-consultation"
    },
    SELECTORS: {
        location: ":scope #location",
        typeOfContact: ":scope #type_of_contact"
    }
};
